import type { EmbedContent, ScriptElement } from '../../schema';

/**
 * Generic iframe embed. We assume authored URLs are trusted (admin-side curation);
 * sandbox set conservatively to allow scripts but block top-navigation.
 */
export function EmbedElement({ element }: { element: ScriptElement }) {
  const c = element.content as EmbedContent | undefined;
  const height = c?.height ?? 360;
  const html = c?.html?.trim();
  if (!html && !c?.url) {
    return (
      <div
        className="grid place-items-center rounded-xl text-[12px] italic"
        style={{
          height,
          border: '1px dashed rgba(60, 45, 25, 0.2)',
          background: 'rgba(60, 45, 25, 0.04)',
          color: 'rgba(60, 45, 25, 0.5)',
        }}
      >
        (no embed)
      </div>
    );
  }
  return (
    <iframe
      title={`embed-${element.id}`}
      // Raw HTML (simulation) via srcDoc takes precedence over a website URL.
      {...(html ? { srcDoc: html } : { src: c!.url })}
      style={{
        width: '100%',
        height,
        borderRadius: 10,
        border: '1px solid rgba(60, 45, 25, 0.15)',
        boxShadow: '0 6px 18px rgba(60, 45, 25, 0.12)',
        background: '#ffffff',
      }}
      sandbox="allow-scripts allow-same-origin allow-popups allow-forms"
    />
  );
}
